import constants from 'constants'

const {
 SAVE_SUPERHOSTS,
 SET_SUPERHOST,
 CLEAN_SUPERHOST
} = constants

const defaultValue = {
    superhost: null,
    superhosts: {
        values: [],
        page: 1,
        per_page: 5,
        count: 0,
        total_pages: 0,
        query: {},
    },
	tmp: {}
}

export const superhosts = (superhosts = defaultValue, {
    type,
	superhost,
    payload
}) => {
    switch(type) {
        case SAVE_SUPERHOSTS:
            return {
                ...superhosts,
                superhosts: {
                    values: payload.superhosts,
                    count: payload.count,
                    page: payload.page,
                    total_pages: payload.totalPages,
                    query: payload.query
                }
            }
		case SET_SUPERHOST:
			return {
				...superhosts,
				tmp: superhost,
				superhost,
			}
		case CLEAN_SUPERHOST:
			return defaultValue
        default:
            return { ...superhosts }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/superhosts.js